import React, { useState } from 'react';
import { message } from 'antd';
import { REACT_APP_ENVIRONMENT } from '@partsbadger/utils';

import { formatSupportContextText } from '@/utils/supportContext';

const SUPPORT_EMAIL = 'sales@parts-badger.com';

/**
 * Copies diagnostic context (user id, LO session id, current URL) for support tickets.
 * Shown in production only.
 */
const ReportProblemLink: React.FC = () => {
    const [loading, setLoading] = useState(false);

    if (REACT_APP_ENVIRONMENT !== 'production') {
        return null;
    }

    const handleClick = async (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        setLoading(true);

        try {
            const body = encodeURIComponent(await formatSupportContextText());
            const subject = encodeURIComponent('Customer portal issue report');
            window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
        } catch {
            message.error('Could not prepare support details. Please contact us by phone.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <a href={`mailto:${SUPPORT_EMAIL}`} onClick={handleClick} style={{ opacity: loading ? 0.6 : 1 }}>
            Report a problem
        </a>
    );
};

export default ReportProblemLink;
